<th scope="row" class="location-header">
    <notification-location [countryCode]="settings.countryCode" [slicNumber]="settings.slicNumber"></notification-location>
</th>
<td [class.error]="statusChangeError">
    <div class="d-flex justify-content-center">
        <status-change-notifications [showStatusCheckboxes]="showStatusCheckboxes" [settings]="settings"
            (statusChanged)="onStatusSettingsChanged($event)"></status-change-notifications>
    </div>
</td>
<td [class.error]="commentError">
    <div class="comment-notifications">
        <on-off-toggle [active]="!dataOutOfDate" [boolValue]="settings?.comment" (onChange)="changeCommentToggle($event)"></on-off-toggle>
    </div>
</td>
<td [class.error]="requestEditedError">
    <div class="request-edited-notifications">
        <on-off-toggle [active]="!dataOutOfDate" [boolValue]="settings?.requestEdited" (onChange)="changeRequestEditedToggle($event)"></on-off-toggle>
    </div>
</td>